export class User {
  firstName: string;
  lastName: string;
  email: string
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/models/user.ts